module.exports = __webpack_public_path__ + "static/media/logo-lg-dark.61d95969.svg";